<template>
  <div>
    <button class="btn btn-info add-tag-btn">
      <i class="fas fa-plus"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "ContactAddTag"
};
</script>

<style scoped>
.add-tag-btn {
  border-radius: 50% !important;
}

.add-tag-btn:active,
.add-tag-btn:focus {
  outline: none;
}
</style>
